import { UrlServiceClient } from "@vp/hamilton-service-clients/dist/src/clients/UrlService";
import { DefaultUrlServiceConfig } from "@vp/hamilton-service-clients/dist/src/config/UrlServiceConfig";
import PageConfig from "../utils/PageConfig";

export const getProductPageUrl = async (mpvId: string, locale: string, tenant: string) => {
  const urlServiceConfig = new DefaultUrlServiceConfig(PageConfig.requestor, tenant);
  const urlServiceClient = new UrlServiceClient(urlServiceConfig);

  const urlData = await urlServiceClient.getProductUrl(mpvId, locale);

  return urlData;
};
